import images from '@assets/images/index'

// Avatar color palette
export const AVATAR_COLORS = [
  '#CC0000',
  '#FF4400',
  '#FF9900',
  '#FFCC00', // Row 1

  '#00CC11',
  '#BBCC00',
  '#EEFF00',
  '#FFEE00', // Row 2

  '#00CC66',
  '#00BB99',
  '#0099CC',
  '#0055FF', // Row 3

  '#660099',
  '#3300CC',
  '#003388',
  '#0033CC', // Row 4

  '#9900CC',
  '#CC33CC',
  '#CC6699',
  '#FFCCCC', // Row 5

  '#EEDD99',
  '#AA7744',
  '#884433',
  '#DD5566', // Row 6

  '#D9D9D9',
  '#AAAAAA',
  '#777777',
  '#333333' // Row 7
] as const

// Sticker requirements for unlocking avatar categories
export const STICKER_REQUIREMENTS = {
  SPORTS: 200,
  MUSIC: 400,
  ANIMALS: 800,
  NATURE: 1000,
  ENTERTAINMENT: 3000,
  SPECIAL_AVATARS: 10000, // High sticker count requirement for special avatars
  SPECIAL_AVATARS_OFFSET: 10, // Level offset for special avatars
  DEFAULT: 0
} as const

// Default avatar settings
export const DEFAULT_AVATAR = {
  COLOR: '#AFDFFF',
  BACKGROUND_COLOR: '#FFFFFF'
} as const

// Avatar type definitions
export interface AvatarItem {
  id: number
  component: React.ComponentType
  name: string
}

// Available skill avatars (unlocked by level progression)
// kids avatars
export const kidRow: AvatarItem[] = [
  { id: 1, component: images.Kid1, name: 'kid1' },
  { id: 2, component: images.Kid2, name: 'kid2' },
  { id: 3, component: images.Kid3, name: 'kid3' },
  { id: 4, component: images.Kid4, name: 'kid4' },
  { id: 5, component: images.Kid5, name: 'kid5' },
  { id: 6, component: images.Kid6, name: 'kid6' },
  { id: 7, component: images.Kid7, name: 'kid7' },
  { id: 8, component: images.Kid8, name: 'kid8' },
  { id: 9, component: images.Kid9, name: 'kid9' },
  { id: 10, component: images.Kid10, name: 'kid10' },
  { id: 11, component: images.Kid11, name: 'kid11' },
  { id: 12, component: images.Kid12, name: 'kid12' },
  { id: 13, component: images.Kid13, name: 'kid13' },
  { id: 14, component: images.Kid14, name: 'kid14' },
  { id: 15, component: images.Kid15, name: 'kid15' },
  { id: 16, component: images.Kid16, name: 'kid16' },
  { id: 17, component: images.Kid17, name: 'kid17' },
  { id: 18, component: images.Kid18, name: 'kid18' },
  { id: 19, component: images.Kid19, name: 'kid19' },
  { id: 20, component: images.Kid20, name: 'kid20' },
  { id: 21, component: images.Kid21, name: 'kid21' },
  { id: 22, component: images.Kid22, name: 'kid22' },
  { id: 23, component: images.Kid23, name: 'kid23' },
  { id: 24, component: images.Kid24, name: 'kid24' },
  { id: 25, component: images.Kid25, name: 'kid25' },
  { id: 26, component: images.Kid26, name: 'kid26' },
  { id: 27, component: images.Kid27, name: 'kid27' },
  { id: 28, component: images.Kid28, name: 'kid28' },
  { id: 29, component: images.Kid29, name: 'kid29' },
  { id: 30, component: images.Kid30, name: 'kid30' }
]

export const skillAvatars: AvatarItem[] = [
  { id: 1, component: images.ScholarBadge, name: 'scholar' },
  { id: 2, component: images.WhizBadge, name: 'whiz' },
  { id: 3, component: images.AceBadge, name: 'star' },
  { id: 4, component: images.RookieIcon, name: 'rookie' },
  { id: 5, component: images.StudentBadge, name: 'student' },
  { id: 6, component: images.ExpertBadge, name: 'expert' },
  { id: 7, component: images.MathematicianBadge, name: 'mathematician' },
  { id: 8, component: images.GeniusBadge, name: 'genius' },
  { id: 9, component: images.MastermindBadge, name: 'mastermind' },
  { id: 10, component: images.ChampionBadge, name: 'champion' }
]

export const skillAvatarsLocked: AvatarItem[] = [
  { id: 1, component: images.ScholarBadgeLock, name: 'scholar' },
  { id: 2, component: images.WhizBadgeLock, name: 'whiz' },
  { id: 3, component: images.AceBadgeLock, name: 'star' },
  { id: 4, component: images.RookieIconLock, name: 'rookie' },
  { id: 5, component: images.StudentBadgeLock, name: 'student' },
  { id: 6, component: images.ExpertBadgeLock, name: 'expert' },
  { id: 7, component: images.MathematicianBadgeLock, name: 'mathematician' },
  { id: 8, component: images.GeniusBadgeLock, name: 'genius' },
  { id: 9, component: images.MastermindBadgeLock, name: 'mastermind' },
  { id: 10, component: images.ChampionBadgeLock, name: 'champion' }
]

// Sports avatars (200+ stickers)
export const sportsAvatars: AvatarItem[] = [
  { id: 1, component: images.FootballIcon, name: 'football' },
  { id: 2, component: images.AmericanFootball, name: 'american football' },
  { id: 3, component: images.BasketBall, name: 'basketball' },
  { id: 4, component: images.Baseball, name: 'baseball' },
  { id: 5, component: images.Volleyball, name: 'volleyball' },
  { id: 6, component: images.TennisIcon, name: 'tennis' },
  { id: 7, component: images.PaddleBall, name: 'paddle ball' },
  { id: 8, component: images.IceHockey, name: 'ice hockey' },
  { id: 9, component: images.HockeyIcon, name: 'hockey' },
  { id: 10, component: images.BoomerangIcon, name: 'boomerang' }
]

// Music avatars (400+ stickers)
export const musicAvatars: AvatarItem[] = [
  { id: 1, component: images.Guitar, name: 'guitar' },
  { id: 2, component: images.ElectricGuitar, name: 'electricguitar' },
  { id: 3, component: images.CasioIcon, name: 'casioicon' },
  { id: 4, component: images.TrumpetIcon, name: 'trumpeticon' },
  { id: 5, component: images.CelloGuitar, name: 'celloguitar' },
  { id: 6, component: images.SaxoPhone, name: 'saxophone' },
  { id: 7, component: images.DrumIcon, name: 'drumicon' },
  { id: 8, component: images.Flute, name: 'flute' },
  { id: 9, component: images.Piano, name: 'piano' },
  { id: 10, component: images.RockGuitar, name: 'rockguitar' }
]

// Animal avatars (800+ stickers)
export const animalAvatars: AvatarItem[] = [
  { id: 1, component: images.CatAvatar, name: 'cat' },
  { id: 2, component: images.DogAvatar, name: 'dog' },
  { id: 3, component: images.SquirrelAvatar, name: 'squirrel' },
  { id: 4, component: images.BuffaloAvatar, name: 'buffalo' },
  { id: 5, component: images.LionAvatar, name: 'lion' },
  { id: 6, component: images.OwlAvatar, name: 'owl' },
  { id: 7, component: images.HorseAvatar, name: 'horse' },
  { id: 8, component: images.TigerAvatar, name: 'tiger' },
  { id: 9, component: images.JagurAvatar, name: 'jagur' },
  { id: 10, component: images.ZebraAvatar, name: 'zebra' }
]

// Nature avatars (1000+ stickers)
export const natureAvatars: AvatarItem[] = [
  { id: 1, component: images.TreeAvatar, name: 'tree' },
  { id: 2, component: images.Christmastree, name: 'christmas' },
  { id: 3, component: images.RoseAvatar, name: 'casioicon' },
  { id: 4, component: images.SunflowerAvatar, name: 'trumpeticon' },
  { id: 5, component: images.leafAvatar, name: 'leaf' },
  { id: 6, component: images.EarthAvatar, name: 'earth' },
  { id: 7, component: images.MarsAvatar, name: 'mars' },
  { id: 8, component: images.MoonAvatar, name: 'moon' },
  { id: 9, component: images.RocketAvatar, name: 'rocket' },
  { id: 10, component: images.TelescopeAvatar, name: 'telescope' }
]

// Entertainment avatars (3000+ stickers)
export const entertainmentAvatars: AvatarItem[] = [
  { id: 1, component: images.ChessAvatar, name: 'chess' },
  { id: 2, component: images.GameConsole, name: 'gameconsole' },
  { id: 3, component: images.SolitaireAvatar, name: 'solitaire' },
  { id: 4, component: images.BowlingAvatar, name: 'bowling' },
  { id: 5, component: images.SkeaterAvatar, name: 'skeater' },
  { id: 6, component: images.SketeBoardAvatar, name: 'sketeboard' },
  { id: 7, component: images.BicycleAvatar, name: 'bicycle' },
  { id: 8, component: images.RacingAvatar, name: 'racing' },
  { id: 9, component: images.AeroPlaneAvatar, name: 'aeroplane' },
  { id: 10, component: images.ShipAvatar, name: 'ship' }
]

// Special sticker avatars (10000+ stickers, unlocked by high level)
export const specialAvatars: AvatarItem[] = [
  { id: 1, component: images.GcSticker, name: 'gc-sticker' },
  { id: 2, component: images.TwoXsticker, name: 'two-x-sticker' },
  { id: 3, component: images.ThreeXsticker, name: 'three-x-sticker' },
  { id: 4, component: images.FourXsticker, name: 'four-x-sticker' },
  { id: 5, component: images.FiveXsticker, name: 'five-x-sticker' },
  { id: 6, component: images.SixXsticker, name: 'six-x-sticker' },
  { id: 7, component: images.SevenXsticker, name: 'seven-x-sticker' },
  { id: 8, component: images.EightXsticker, name: 'eight-x-sticker' },
  { id: 9, component: images.NineXsticker, name: 'nine-x-sticker' },
  { id: 10, component: images.TenXsticker, name: 'ten-x-sticker' }
]

export const specialAvatarsLocked: AvatarItem[] = [
  { id: 1, component: images.GcStickerLock, name: 'gc-sticker' },
  { id: 2, component: images.TwoXstickerLock, name: 'two-x-sticker' },
  { id: 3, component: images.ThreeXstickerLock, name: 'three-x-sticker' },
  { id: 4, component: images.FourXstickerLock, name: 'four-x-sticker' },
  { id: 5, component: images.FiveXstickerLock, name: 'five-x-sticker' },
  { id: 6, component: images.SixXstickerLock, name: 'six-x-sticker' },
  { id: 7, component: images.SevenXstickerLock, name: 'seven-x-sticker' },
  { id: 8, component: images.EightXstickerLock, name: 'eight-x-sticker' },
  { id: 9, component: images.NineXstickerLock, name: 'nine-x-sticker' },
  { id: 10, component: images.TenXstickerLock, name: 'ten-x-sticker' }
]

// Combined available avatars for selection
export const getAllAvailableAvatars = (): AvatarItem[] => [
  ...skillAvatars,
  ...sportsAvatars,
  ...musicAvatars,
  ...animalAvatars,
  ...kidRow
]
